


























































































import {Component, Ref, Vue} from 'vue-property-decorator'
import Paging from 'biz-ts/src/api/Paging';
import MqttEventWrapper from "@/model/MqttEventWrapper";
import MqttEventApi, {EventPqForm} from '@/module/mqtt/MqttEventApi';
import {Container} from "typescript-ioc";
import Pagination from '@/component/Pagination/index.vue'
import RealtimeRefresh from "@/component/Switch/realtime-refresh.vue";
import PaginationTable from "@/component/Table/pagination-table.vue";
import VueJsonPretty from 'vue-json-pretty';
import InfoDialog from "@/component/Dialog/info-dialog.vue";
import {mqttEventTypeZh} from "@/module/mqtt/MqttEvent";
import RefreshButton from "@/component/Button/refresh-button.vue";
import IdColumn from "@/component/Table/id-column.vue";

@Component({
  components: {
    IdColumn,
    Pagination,
    RealtimeRefresh,
    PaginationTable,
    VueJsonPretty,
    InfoDialog,
    RefreshButton,
  }
})
export default class MqttEventView extends Vue {

  private mqttApi = Container.get(MqttEventApi)

  @Ref()
  private ptable!: PaginationTable

  @Ref()
  private jsonDialog!: InfoDialog

  private active?: MqttEventWrapper = undefined

  private get activeEvent() {
    if (this.active)
      return JSON.parse(this.active.eventJson)
    else return undefined
  }

  private eventTypeZh = mqttEventTypeZh

  private paging = new Paging<MqttEventWrapper>()
  private pqForm = new EventPqForm()

  async created() {
    await this.getPaging()
  }

  private async getPaging() {
    return this.mqttApi.paging(this.pqForm)
  }

  private refresh() {
    this.ptable?.refresh()
  }

  private async search(reset = false) {
    if (reset)
      this.pqForm.currentPage = 1
    this.refresh()
  }

  private handleDetailClick(wrapper: MqttEventWrapper) {
    this.active = wrapper
    this.jsonDialog.open()
  }
}
